import type { FC } from 'react'
import React from 'react'

import type { IEmptyProps } from 'components/uiKit/Empty'
import { ModalTable } from 'components/uiKit/Table'
import type { PaginationConfig, SortConfig } from 'components/uiKit/Table/types'
import type { FinderFolderItem } from 'store/models'

import { COLUMNS_CONFIG } from './config'

export const MODAL_MOVE_FINDER_TABLE_NAME = 'modalMoveFinderTable'

interface IFolderTableProps {
  folders: FinderFolderItem[]
  isLoading?: boolean
  totalFolders: number
  setTargetGroupId: (id: string) => void
  paginationConfig: PaginationConfig
  sortConfig: SortConfig
  empty?: IEmptyProps
}

const FolderTable: FC<IFolderTableProps> = ({
  folders,
  isLoading,
  totalFolders,
  setTargetGroupId,
  paginationConfig,
  sortConfig,
  empty,
}) => (
  <ModalTable
    columns={COLUMNS_CONFIG}
    dataSource={folders}
    defaultSort='name'
    empty={empty}
    loading={isLoading}
    name={MODAL_MOVE_FINDER_TABLE_NAME}
    onClickRow={(_e, group) => setTargetGroupId(group.id)}
    paginationConfig={paginationConfig}
    sortConfig={sortConfig}
    total={totalFolders}
    pagination
  />
)

export default FolderTable
